<template>
  <v-container class="mt-10">
    <h1 class="text-center mb-5">This Week's Menu</h1>
    <alerts
      module="menu"
    />
    <product-items-loading v-if="loading" />
    <template v-else-if="filteredMenu">
      <v-row>
        <v-col
          v-for="item in filteredMenu"
          cols="12"
          sm="6"
          md="4"
          lg="3"
          :key="item.id"
        >
          <v-card>
            <product-image class="cursor-pointer " :product="item" @click.native="() => goToDetails(item)" />
            <v-card-title class="text-wrap">{{ item.title }}</v-card-title>
          </v-card>
        </v-col>
      </v-row>
    </template>
  </v-container>
</template>
<script>
import ProductImage from '@/components/utilities/productImage.vue';
import ProductItemsLoading from '../utilities/productItemsLoading.vue';
import { mapState } from 'vuex';
import helpers from '@/helpers/helpers.js';

export default {
  name: 'MenuItems',
  components: {
    ProductImage,
    ProductItemsLoading
  },
  props: {
    productHandle: {
      type: String,
      default: ''
    }
  },
  data: function () {
    return {
      loading: false
    };
  },
  methods: {
    goToDetails: function (selectedProduct) {
      this.$router.push({
        name: 'menuDetails',
        params: {
          id: selectedProduct.id
        }
      });
    }
  },
  computed: {
    menuType: function () {
      if (this.productHandle.includes('fasting')) {
        return 'This Weeks Intermittent Fasting Menu';
      } else if (this.productHandle.includes('vegan')) {
        return 'This Weeks Vegan Menu';
      } else if (this.productHandle.includes('pescatarian')) {
        return 'This Weeks Pescatarian Menu';
      } else if (this.productHandle.includes('flexitarian')) {
        return 'This Weeks Flexitarian Menu';
      }
      return '';
    },
    thisMonday: function () {
      let date = new Date();
      date = new Date(date);
      const day = date.getDay();
      // eslint-disable-next-line eqeqeq
      const diff = date.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
      const thisMonday = new Date(date.setDate(diff));

      return helpers.formatDate(thisMonday, { withTime: false, dash: true, format: 'MMDDYYYY' });
    },
    ...mapState('menu', {
      menu: state => state.data
    }),
    filteredMenu: function () {
      if (this.menu) {
        return this.menu.filter(menuItem => {
          return menuItem.tags.includes(this.menuType) && menuItem.tags.includes(this.thisMonday);
        });
      }
      return [];
    }
  },
  created: function () {
    this.$store.dispatch('menu/getMenu');
  }
};
</script>
<style scoped>
.productImg {
  max-width: 30%;
}
</style>
